import React, { useEffect } from "react";
import styled from "styled-components";

import { useParams } from "react-router-dom";
import PageHeader from "../../components/PageHeader.tsx";
import { useQuery } from "@tanstack/react-query";
import {
  deleteOrderProduct,
  getOrderDetails,
  sendEmail,
  updateOrderNote,
  updateOrderPaymentStatus,
  updateOrderQuantity,
  updateOrderStatus,
} from "../../../services/orderService.js";
import Table from "../../components/core-components/Table.tsx";
import { useAuth } from "../../../hooks/useAuth.jsx";
import { toast, ToastContainer } from "react-toastify";
import Button from "../../components/core-components/Button.tsx";
import Modal from "../../components/core-components/Modal.tsx";
import InvoiceComponent from "../../components/InvoiceComponent.tsx";
import {
  paymentStatus as paymentStatusOptions,
  statusValues,
} from "../../../utils/constants.ts";
import InputField from "../../components/core-components/InputField.tsx";
import { getStatusColor } from "../../../utils/utils.ts";
import { MdOutlineDelete } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { IoSaveOutline } from "react-icons/io5";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  box-sizing: border-box;
  background-color: white;
  width: calc(100% - 2rem);
  min-height: 80%;
  border-radius: 8px;
  padding: 20px;

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;
const OrderItem = styled.div`
  background-color: white;
  flex: 1;
  border-radius: 8px;
  padding: 16px;

  justify-content: space-between;
  align-items: center;

  p {
    margin: 2px 0;
    font-size: 14px;
    font-weight: 400;
  }
`;

const OrderDetailItem = styled.div`
  padding: 2px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  p {
    flex: 1;
  }
  & > div {
    flex: 1;
  }
`;

const OrderDetailNoteItem = styled.div`
  padding: 2px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  & > div {
    hight: 50%;
  }
`;
const CustomDropdown = styled.div<{
  color: string;
  backgroundColor?: string;
}>`
  flex: 1;
  select {
    background-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ color }) => color};
    border: none;
    outline: none;
    font-size: 1rem;
    padding: 4px;
    border-radius: 4px;
  }

  option {
    background-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ color }) => color};
  }
`;

const OrderWrapper = styled.div`
  display: flex;

  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`;

const notifyErr = () =>
  toast.error("Nu s-a putut face update la statusul comenzii!", {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });

const notifySucces = () =>
  toast.success("Statusul comenzii a fost actualizat cu succes!", {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });

const OrderDetails: React.FC = () => {
  const { token } = useAuth();
  const { orderId } = useParams();
  const [status, setStatus] = React.useState("");
  const [note, setNote] = React.useState("");
  const [paymentStatus, setPaymentStatus] = React.useState("");
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isNoteUpdate, setIsNoteUpdate] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [quantity, setQuantity] = React.useState<string | number>("");
  const [awb, setAwb] = React.useState("");

  const handleSend = async (mail) => {
    try {
      await sendEmail(mail);
    } catch (error) {
      console.error("Error sending email", error);
    }
  };
  const handleDelete = async (productId) => {
    try {
      await deleteOrderProduct(orderId, productId, token);
      refetch();
    } catch (error) {
      console.error("Error deleting", error);
    }
  };
  const handleUpdate = async (productId) => {
    try {
      await updateOrderQuantity(orderId, productId, quantity, token);
      refetch();
    } catch (error) {
      console.error("Error sending email", error);
    }
  };
  useEffect(() => {
    const updateStatus = async () => {
      if (status && status !== order?.status) {
        // Call the API to update the order status
        try {
          await updateOrderStatus(orderId, status, token);
          notifySucces();
          if (status === statusValues.DELIVERED) {
            await handleSend({
              subject: "Comanda livrată #" + orderId,
              toAddress: order.email,
              content: `<div>
                  <p>
                    Vești bune ! Comanda ta a fost livrată și va ajunge la tine
                    în cel mai scurt timp !
                  </p>
                  ${
                    awb
                      ? `<p>
      Urmărește comanda ta pe site-ul Sameday, folosind numărul de AWB ${awb}
    </p>`
                      : ""
                  }
                  <p>
                    Pentru orice întrebări sau nelămuriri, nu ezita să ne
                    contactezi.
                  </p>
                  <p>Mulțumim, FiloPrint !</p>
                  <img
                    src="https://filoprint.ro/images/header-logo.png"
                    alt="Logo"
                    width="100"
                  />
                  <div>Telefon: 0724702368</div>
                  <div>
                    Site: https://filoprint.ro/
                  </div>
                </div>
          `,
            });
          }
        } catch (error) {
          console.error("Error updating order status:", error);
          notifyErr();
        }
      }
    };

    updateStatus();
  }, [status, orderId, token]);

  useEffect(() => {
    const updateStatus = async () => {
      if (paymentStatus && paymentStatus !== order?.paymentStatus) {
        // Call the API to update the order status
        try {
          await updateOrderPaymentStatus(orderId, paymentStatus, token);
          notifySucces();
        } catch (error) {
          console.error("Error updating order status:", error);
          notifyErr();
        }
      }
    };

    updateStatus();
  }, [paymentStatus, orderId, token]);

  const updateNoteSave = async () => {
    if (note) {
      // Call the API to update the order status
      try {
        await updateOrderNote(orderId, note, token);
        setIsNoteUpdate(false);
        notifySucces();
      } catch (error) {
        console.error("Error updating order note:", error);
        notifyErr();
      }
    }
  };

  const { data: order, refetch } = useQuery({
    queryKey: ["categorydetails", orderId],
    queryFn: () => getOrderDetails(orderId),
    enabled: !!orderId,
  });

  return (
    <Wrapper>
      <PageHeader
        pageTitle="Detalii comandă"
        actionButtons={[
          {
            label:
              order?.invoice !== null
                ? "Descarcă factură"
                : "Generează factură",
            onClick: () => {
              setIsModalOpen(true);
            },
            isEmpty: true,
          },
        ]}
      />

      {isModalOpen && (
        <Modal
          name="order-invoice-modal"
          title={
            order?.invoice !== null ? "Descarcă factură" : "Generează factură"
          }
          onClose={() => {
            setIsModalOpen(false);
          }}
          content={
            <InvoiceComponent
              order={order}
              token={token}
              refetchOrder={refetch}
            />
          }
        />
      )}
      <Content>
        {order && orderId && Number(orderId) > 0 ? (
          <>
            <OrderWrapper>
              <OrderItem>
                <OrderDetailItem>
                  <p>Numărul comenzii:</p>
                  <p>
                    <b>{order.orderID}</b>
                  </p>
                </OrderDetailItem>
                <OrderDetailItem>
                  <p>Staus comandă:</p>
                  {order && (
                    <CustomDropdown
                      backgroundColor={
                        getStatusColor(status ? status : order?.status)
                          .backgroundColor
                      }
                      color={
                        getStatusColor(status ? status : order?.status).color
                      }
                    >
                      <select
                        name={"status"}
                        value={status ? status : order.status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        {Object.entries(statusValues).map(([key, value]) => (
                          <option key={key} value={value}>
                            {value}
                          </option>
                        ))}
                      </select>
                    </CustomDropdown>
                  )}
                </OrderDetailItem>

                <OrderDetailItem>
                  <p>Staus plată:</p>
                  {order && (
                    <CustomDropdown
                      backgroundColor={
                        getStatusColor(
                          paymentStatus ? paymentStatus : order.paymentStatus
                        ).backgroundColor
                      }
                      color={
                        getStatusColor(
                          paymentStatus ? paymentStatus : order.paymentStatus
                        ).color
                      }
                    >
                      <select
                        name={"payment-status"}
                        value={
                          paymentStatus ? paymentStatus : order.paymentStatus
                        }
                        onChange={(e) => {
                          setPaymentStatus(e.target.value);
                        }}
                      >
                        {Object.entries(paymentStatusOptions).map(
                          ([key, value]) => (
                            <option key={key} value={value}>
                              {value}
                            </option>
                          )
                        )}
                      </select>
                    </CustomDropdown>
                  )}
                </OrderDetailItem>
                <OrderDetailItem>
                  <p>Metoda de plată:</p>
                  <p>
                    <b>{order.paymentOption}</b>
                  </p>
                </OrderDetailItem>
                <OrderDetailItem>
                  <p>Data comenzii:</p>
                  <p>
                    <b>{order.orderDate}</b>
                  </p>
                </OrderDetailItem>

                <OrderDetailItem>
                  <p>Metoda de livrare:</p>
                  <p>
                    <b>{order.shippingOption}</b>
                  </p>
                </OrderDetailItem>

                <OrderDetailItem>
                  <p>Preț total:</p>
                  <p>
                    <b>{order.totalPrice} lei</b>
                  </p>
                </OrderDetailItem>
                <OrderDetailItem>
                  <p>AWB:</p>
                  <InputField
                    name="awb"
                    type="text"
                    value={awb}
                    onChange={(e) => {
                      setAwb(e.target.value);
                    }}
                    placeholder={"AWB"}
                  />
                </OrderDetailItem>
              </OrderItem>

              <OrderItem>
                <OrderDetailItem>
                  <p>Nume client:</p>
                  <p>
                    <b>
                      {order.firstName} {order.lastName}
                    </b>
                  </p>
                </OrderDetailItem>
                <OrderDetailItem>
                  <p>Telefon client:</p>
                  <p>
                    <b>{order.phoneNumber}</b>
                  </p>
                </OrderDetailItem>
                <OrderDetailItem>
                  <p>Email:</p>
                  <p>
                    <b>{order.email}</b>
                  </p>
                </OrderDetailItem>
                <OrderDetailItem>
                  <p>Adresa de livrare:</p>
                  <p>
                    <b>
                      {order.street}, {order.city}, {order.county}, Romania
                    </b>
                  </p>
                </OrderDetailItem>
                <OrderDetailNoteItem>
                  <InputField
                    name="note"
                    type="textarea"
                    value={note ? note : order.message}
                    onChange={(e) => {
                      setNote(e.target.value);
                      setIsNoteUpdate(true);
                    }}
                    placeholder={"Notite"}
                    label="Mesaj"
                  />
                  {isNoteUpdate && (
                    <Button
                      id="save-invoice"
                      onClick={updateNoteSave}
                      text="Save"
                      backgroundColor={"var(--primary-brown)"}
                      color="white"
                      isFullWidth
                    />
                  )}
                </OrderDetailNoteItem>
              </OrderItem>
            </OrderWrapper>
            <Table
              columns={[
                { title: "ID", key: "productID" },
                { title: "Produs", key: "productName" },
                { title: "Cantitate", key: "productCantity" },
                { title: "Preț", key: "salePrice" },
                { title: "Total", key: "totalPrice" },
                { title: "Buc", key: "editQuantity" },
                { title: "Sterge", key: "delete" },
              ]}
              rows={order.orderDetails.map((item) => ({
                ...item,
                productCantity: item.productCantity + " buc",
                salePrice: item.salePrice + " lei",
                totalPrice: item.salePrice * item.productCantity + " lei",
                editQuantity: isEdit ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      gap: "1rem",
                      alignItems: "center",
                    }}
                  >
                    <InputField
                      name="quantity"
                      type="number"
                      value={quantity.toString()}
                      onChange={(e) => {
                        setQuantity(Number(e.target.value));
                      }}
                      placeholder={"Cantitate"}
                    />
                    <button
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "1.5rem",
                      }}
                      onClick={() => {
                        handleUpdate(item.productID);
                        setIsEdit(false);
                      }}
                    >
                      <IoSaveOutline />
                    </button>
                  </div>
                ) : (
                  <button
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.5rem",
                    }}
                    onClick={() => {
                      setIsEdit(true);
                    }}
                  >
                    <AiOutlineEdit />
                  </button>
                ),
                delete: (
                  <button
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.5rem",
                    }}
                    onClick={() => {
                      handleDelete(item.productID);
                    }}
                  >
                    <MdOutlineDelete />
                  </button>
                ),
              }))}
            />
          </>
        ) : (
          <p>Nu există această comandă</p>
        )}
      </Content>
      <ToastContainer />
    </Wrapper>
  );
};

export default OrderDetails;
